import Divider from "../../baseComponents/divider/Divider";
import { useTranslation } from "react-i18next";
import Section from "../../baseComponents/section/Section";
import iphone from '../../asset/export/devices.png';
import addto from '../../asset/export/Add_to.png';
import shutter from '../../asset/export/shutterstock1.png';
import ApplePayTDB from '../../asset/export/ApplePayTDB.png';
import { Fragment } from "react";

const Ass = () => {
    const { t } = useTranslation();





    return (
        <Divider cl="bg-[url('/src/asset/bg9.jfif')]   bg-cover  relative">

            <div className=" md:h-auto grid md:grid-cols-5 gap-4  items-start ">

                <div className="w-full h-full col-span-2 flex justify-center items-center">
                    <img src={iphone} className='bg-transparent w-full object-contain m-0 p-0' alt="" />
                </div>
                <div className="w-full col-span-3  flex flex-col md:py-10">
                    <Section title={t("How_add_card")} text={<Fragment >
                        <ul className="list-disc -my-4">
                            <li className="ml-6 my-4 leading-6 text-start"><div className="flex flex-wrap "><p className="px-2">{t("How_add_card_T1")} </p> <span ><img alt="" src={addto} className='bg-transparent h-6  object-contain mr-2' /> </span><p >  {t("How_add_card_But")}</p></div></li>
                            <li className="ml-6  my-4 leading-6 text-start">{t("How_add_card_T2")}</li>
                        </ul>
                    </Fragment>} cl=' md:text-3xl xl:text-[40px]' />
                    <Section title={t("Where_to_use")} text={<div>
                        <div className="flex flex-wrap justify-start items-center leading-6"><p className="px-2"> {t("Where_to_use_T1") + "   "} </p> <img alt="" src={ApplePayTDB} className=' h-8  object-contain mr-2' /><p className="px-2">{t("Where_to_use_T2")} </p>  <img alt="" src={shutter} className=' h-8  object-contain mr-2' /> <p>{t("Where_to_use_T3")}</p></div>
                    </div>} cl=' md:text-3xl xl:text-[40px]' />
                    <Section title={t("Cards")} text={
                        <ul className="list-disc">
                            <li className="ml-6  text-start">
                                <div className="flex flex-wrap gap-3">
                                    <b>{t("C1")} </b>  - {t("C11")}
                                </div>
                            </li>
                            <li className="ml-6 text-start">
                                <p className="flex flex-wrap gap-3 ">
                                    <b>{t("C2")} </b> - {t("C22")}
                                </p>
                            </li>
                        </ul>} cl=' md:text-3xl xl:text-[40px]' />

                </div>

            </div>
        </Divider >
    );
};
export default Ass;